import { render, staticRenderFns } from "./ReferenceNumberModal.vue?vue&type=template&id=aa460812&scoped=true"
import script from "./ReferenceNumberModal.vue?vue&type=script&lang=ts"
export * from "./ReferenceNumberModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa460812",
  null
  
)

export default component.exports